import moment from 'moment';

export const DateText = ({ date }) => moment(date).format('DD/MM/YYYY');
